// src/components/WhatsAppFloat.js
import React from 'react';
import './WhatsAppFloat.css';

function WhatsAppFloat() {
  return (
    <a 
      href="https://wa.me/5493544639290?text=Hola%20OLPEAL,%20me%20interesan%20sus%20productos" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="whatsapp-float"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
}

export default WhatsAppFloat;